module.exports = __webpack_public_path__ + "img/biaoqian_bowei.2dfd1c2e.png";